import { parseAsBoolean, parseAsString, useQueryStates } from 'nuqs'

export function useFilterGenericContent() {
  return useQueryStates({
    freeSearch: parseAsString,
    contentType: parseAsString,
    relativeKeys: parseAsString,
    searchTags: parseAsString,
    isActive: parseAsBoolean.withDefault(false),
  })
}
